import React, { useEffect, useRef, useState } from "react";
import { FiBell } from "react-icons/fi";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../constante";

export default function AdminNotifications() {
  const [open, setOpen] = useState(false);

  const [pendingOrders, setPendingOrders] = useState(0);
  const [pendingUsers, setPendingUsers] = useState(0);

  const rawOrdersRef = useRef([]);
  const rawUsersRef = useRef([]);

  const menuRef = useRef(null);
  const navigate = useNavigate();

  const fetchCounts = async () => {
    try {
      // =========================
      // COMMANDES
      // =========================

      const { data: orders } = await axios.get(
  `${BASE_URL}/api/orders`,
  { withCredentials: true }
);

const pendingOrdersList = (orders || []).filter(
  (order) =>
    (order.status || "").toLowerCase() === "en attente"
);

      setPendingOrders(pendingOrdersList.length);


      // =========================
      // DEMANDES UTILISATEURS
      // =========================

      const { data: users } = await axios.get(
        `${BASE_URL}/api/auth/pending-requests`,
        { withCredentials: true }
      );

      const pendingUsersList = Array.isArray(users) ? users : [];

      rawUsersRef.current = pendingUsersList;

      const seenUserIds = JSON.parse(
        localStorage.getItem("notif_seen_user_ids") || "[]"
      );

      const newUsers = pendingUsersList.filter(
        (user) => !seenUserIds.includes(user._id)
      );

      setPendingUsers(newUsers.length);

    } catch (error) {
      console.error(
        "❌ Erreur notifications admin:",
        error
      );
    }
  };


  // =========================
  // CHARGEMENT
  // =========================

  useEffect(() => {
    fetchCounts();

    const id = setInterval(fetchCounts, 10000);

    return () => clearInterval(id);
  }, []);


  // =========================
  // CLICK EXTÉRIEUR
  // =========================

  useEffect(() => {
    const onDocClick = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener(
      "mousedown",
      onDocClick
    );

    return () =>
      document.removeEventListener(
        "mousedown",
        onDocClick
      );
  }, []);


  const total = pendingOrders + pendingUsers;


  // =========================
  // COMMANDES VUES
  // =========================

  const handleOrdersClick = () => {
    const ids = rawOrdersRef.current.map(
      (order) => order._id
    );

    localStorage.setItem(
      "notif_seen_order_ids",
      JSON.stringify(ids)
    );

    setPendingOrders(0);
    setOpen(false);

    navigate("/admin/orders");
  };


  // =========================
  // USERS VUS
  // =========================

  const handleUsersClick = () => {
    const ids = rawUsersRef.current.map(
      (user) => user._id
    );

    localStorage.setItem(
      "notif_seen_user_ids",
      JSON.stringify(ids)
    );

    setPendingUsers(0);
    setOpen(false);

    navigate("/admin/pending-users");
  };


  return (
    <div
      className="admin-notifications"
      ref={menuRef}
    >

      <button
        className="admin-bell-btn"
        onClick={() => setOpen((v) => !v)}
        aria-label="Notifications"
      >

        <FiBell size={20} />

        {total > 0 && (
          <span className="badge-dot">
            {total}
          </span>
        )}

      </button>


      {open && (
        <div className="admin-bell-menu">

          <div className="menu-header">
            Notifications
          </div>


          {pendingOrders > 0 && (

            <button
              className="menu-item"
              onClick={handleOrdersClick}
            >

              Commandes en attente

              <span className="count-pill ms-auto">
                {pendingOrders}
              </span>

            </button>

          )}


          {pendingUsers > 0 && (

            <button
              className="menu-item"
              onClick={handleUsersClick}
            >

              Demandes d'inscription

              <span className="count-pill ms-auto">
                {pendingUsers}
              </span>

            </button>

          )}


          {total === 0 && (

            <div className="menu-empty">
              Aucune notification
            </div>

          )}

        </div>
      )}

    </div>
  );
}
